import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { ConfiguracaoCampoObrigatorioService } from '@shared/services/apis/financas/configuracao-campo-obrigatorio.service';
import { AlertService, AlertType } from '@shared/services/alert.service';
import { FuncionalidadeEnum } from '@shared/enums/usuario/funcionalidade.enum';
import { ModuloEnum } from '@shared/enums/usuario/modulo.enum';
import { HeaderComponent } from '@shared/components/header/header.component';
import { FooterActionComponent } from '@shared/components/footer-action/footer-action.component';
import { LoadingBoxComponent } from '@shared/components/loading-box/loading-box.component';
import { CamposObrigatoriosSecaoComponent } from '@shared/components/campos-obrigatorios-secao/campos-obrigatorios-secao.component';
import { TelaComCamposStruct } from '@shared/services/structs/financas/tela-com-campos.struct';

@Component({
    selector: 'app-campos-obrigatorios-financas',
    standalone: true,
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        HeaderComponent,
        FooterActionComponent,
        LoadingBoxComponent,
        CamposObrigatoriosSecaoComponent
    ],
    templateUrl: './campos-obrigatorios-financas.component.html',
    styleUrls: ['./campos-obrigatorios-financas.component.css']
})
export class CamposObrigatoriosFinancasComponent implements OnInit {

    public isLoading = false;
    public isSaving = false;
    public funcionalidadeEnum = FuncionalidadeEnum.Configuracoes_Financas;
    public moduloEnum = ModuloEnum.Configuracoes;
    public listaTelaComCampos: TelaComCamposStruct[] = [];
    public telaComSeletorAberto: TelaComCamposStruct | null = null;

    constructor(
        private configuracaoCampoObrigatorioService: ConfiguracaoCampoObrigatorioService,
        private alertService: AlertService,
        private router: Router
    ) { }

    ngOnInit(): void {
        this.carregarConfiguracoes();
    }

    carregarConfiguracoes(): void {
        this.isLoading = true;
        this.configuracaoCampoObrigatorioService.getAll().subscribe({
            next: (response) => {
                this.isLoading = false;
                if (response.isError) {
                    this.alertService.show('Alerta', response.errorDescription, AlertType.warning);
                    return;
                }
                this.listaTelaComCampos = response.listaTelaComCampos;
            },
            error: () => {
                this.isLoading = false;
                this.alertService.show('Erro', 'Erro ao carregar configurações de campos obrigatórios', AlertType.error);
            }
        });
    }

    onSeletorAbertoChange(tela: TelaComCamposStruct, aberto: boolean): void {
        this.telaComSeletorAberto = aberto ? tela : null;
    }

    salvar(): void {
        this.isSaving = true;
        this.configuracaoCampoObrigatorioService.update({
            listaCampos: this.listaTelaComCampos
                .flatMap(tela => tela.listaCampos)
                .map(campo => ({ idCampo: campo.idCampo, isObrigatorio: campo.isObrigatorio }))
        }).subscribe({
            next: (response) => {
                this.isSaving = false;
                if (response.isError) {
                    this.alertService.show('Aviso!', response.errorDescription, AlertType.warning);
                    return;
                }
                this.alertService.show('Sucesso', 'Configuração salva com sucesso!', AlertType.success);
                this.voltar();
            },
            error: () => {
                this.isSaving = false;
                this.alertService.show('Erro', 'Erro ao conectar com a API', AlertType.error);
            }
        });
    }

    voltar(): void {
        this.router.navigate(['/configuracoes/financas']);
    }
}
